



































































































































import { Component, Mixins, Prop, Inject, Watch } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { Sorters } from "@/data/table";

// Types
import { ITableConfig } from "@/models/tables";
import {
  ICatalogueProviderData,
  ICatalogueProviderMethods
} from "@/models/providers/catalogue";
import { IFilter, ISorter } from "@/models/tables";
import { IProduct } from "@/models/products";
import { ListDisplayMode } from "@/data/constants";
import { UserMetaKeys } from "@/data/enums/users";

@Component({
  components: {
    "product-list-item": () =>
      import("@/components/app/admin/catalogue/products/productListItem.vue")
  }
})
export default class ProductSearch extends Mixins(
  RequestPromises,
  FilteringSortingTableStore
) {
  @Inject({ from: "catalogueProviderData" })
  public readonly $catalogueData!: () => ICatalogueProviderData;

  @Inject({ from: "catalogueProviderMethods" })
  public readonly $catalogueMethods!: ICatalogueProviderMethods;

  // Props

  @Prop({ default: null })
  public selectedProducts!: {
    id: IProduct["id"];
    category_id: IProduct["category_id"];
  }[];

  @Prop({ default: null })
  public disabledProducts!: IProduct["id"][];

  @Prop({ default: () => ({}) })
  public readonly manualFilters!: Record<string, any>;

  @Prop({ default: false })
  public disableBundles!: boolean;

  @Prop({ default: true })
  public isMultiselect!: boolean;

  @Prop({ default: () => [ListDisplayMode.TREE, ListDisplayMode.GRID] })
  public availableModes!: ListDisplayMode[];

  // Data

  public dataModule: DataModules = DataModules.CATALOGUE;
  public displayModeStoragePath = UserMetaKeys.UI_CATALOGUE_DISPLAY_MODE;
  public filters: IFilter[] = this.catalogueData.filters;
  public sorters: ISorter[] = this.catalogueData.sorters;
  public defaults: ITableConfig = {
    limit: 12,
    sort: {
      field: "created_at",
      direction: Sorters.DESCENDING
    },
    filters: []
  };

  // Computed

  public get catalogueData() {
    return this.$catalogueData();
  }

  public get showTreeView(): boolean {
    if (!this.availableModes.includes(ListDisplayMode.TREE)) return false;
    const userMode: ListDisplayMode = this.$store.getters[`user/meta`](
      UserMetaKeys.UI_CATALOGUE_DISPLAY_MODE
    );
    return userMode === ListDisplayMode.TREE;
  }

  // Lifecycle methods

  public created() {
    this.apiProps = {
      with: [
        "image",
        "prices",
        "provision_category",
        "provision_provider",
        "provision_provider.logos",
        "provision_configuration"
      ].join(),
      "filter[product_type]": this.catalogueData.productTypes.join(","),
      ...this.manualFilters
    };

    this.getData();

    if (!this.showTreeView) this.getData();

    this.$bus.$on("refreshProductSearchTable", () => {
      this.getData({ ignoreStored: true });
    });
  }

  public beforeDestroy() {
    this.$bus.$off("refreshProductSearchTable");
  }

  // Methods

  public refreshView() {
    if (!this.showTreeView) {
      this.getData({ ignoreStored: true });
      return;
    }

    this.$bus.$emit("refreshProductSearchTree");
  }

  public getPConfigurationName(configurationId: string) {
    return _.get(
      _.find(this.catalogueData.configurations, ["id", configurationId]),
      "name",
      this.$t("_.default_configuration")
    );
  }

  public getBillingTermsCounter(prices) {
    return _.uniqBy(prices, "billing_cycle_months").length;
  }

  public selectProduct(selectedProduct, value) {
    this.$emit("selectProduct", selectedProduct, value);
  }

  // Watchers

  @Watch("showTreeView")
  public onShowTreeViewChange(newValue, oldValue) {
    if (_.isEqual(newValue, oldValue) || this.showTreeView) return;

    this.getData({ ...this.defaults, ignoreStored: true });
  }

  @Watch("config.filters")
  public onActiveFiltersChange() {
    if (
      this.showTreeView &&
      _.isEmpty(this.config.filters) &&
      _.isEqual(this.config.sort, this.defaults.sort)
    )
      return;

    if (
      this.$store.getters["user/meta"](
        UserMetaKeys.UI_CATALOGUE_DISPLAY_MODE
      ) !== ListDisplayMode.GRID
    ) {
      // If there is any filter applied change to GRID view
      this.$store.dispatch(`user/addMeta`, {
        [UserMetaKeys.UI_CATALOGUE_DISPLAY_MODE]: ListDisplayMode.GRID
      });
    }
  }
}
